module.exports = __webpack_public_path__ + "files/b6cbb6ac054e41139b0cd8090c298f3a.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/flags-2.png
// module id = 533
// module chunks = 76